/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */
   
import gql from "graphql-tag";

// Simple query, with no parameters or fields (returns just a string)
export const ZendeskSsoTokenQuery = gql`
  query ZendeskSsoTokenQuery {
    zendeskSsoToken: getZendeskSsoToken {
      token
      ssoUrl
      landingPage
    }
  }
`;

export interface ZendeskSsoTokenData {
  zendeskSsoToken: {
    token: string;
    ssoUrl: string;
    landingPage: string;
  };
}
